export default {
  API_ENDPOINT: 'https://arcane-springs-74617.herokuapp.com/api',
  TOKEN_KEY: 'Auth'
}